import Image from "next/image";
import Link from "next/link";

import React from "react";

import { twMerge } from "tailwind-merge";

import { useGlobalState } from "hooks/useGlobalState";

type Props = {
  avatarUrl: string;
  slug: string;
  id: string;
  name: string;
  title: string;
  children: any;
  type?: "company" | "user";
};

const ProfileSnippet = ({
  avatarUrl,
  slug,
  id,
  children,
  title,
  name,
  type = "user",
}: Props) => {
  const [_, setShowFeedSettings] = useGlobalState(
    "showFeedSettingsModal",
    false
  );

  return (
    <div key={id} className="mb-[20px] flex items-center">
      <Link
        className="mr-[8px] flex leading-[1.3] items-center"
        onClick={() => {
          setTimeout(() => {
            setShowFeedSettings(false);
          }, 0);
        }}
        href={
          type === "user" ? `/profiles/${slug}` : `/companies/${slug}/research`
        }
      >
        <div className="w-[40px]">
          <Image
            className={twMerge(
              type === "user" && "rounded-full",
              "border border-solid border-black/5"
            )}
            src={avatarUrl}
            width={35}
            height={35}
            alt={name}
          />
        </div>

        <div className="mr-[10px]  w-[250px]">
          <h3 className="text-[15px] m-0 font-bold truncate">{name}</h3>
          <h6 className="text-[#999] text-[13px] m-0">{title}</h6>
        </div>
      </Link>
      {children}
    </div>
  );
};

export default ProfileSnippet;
